<template>
  <div v-if="damageImageModal">
    <h5>Damage photo</h5>
    <img :src="damageImageModal || 'img/image_not_found.png'" alt="damage" class="img-damage img-thumbnail">
    <div v-if="damageInfo" class="mt-2">
      <div v-if="damageInfo.part" class="mb-2">
        <strong>Part:</strong>
        <div class="damage-info-value">{{ damageInfo.part.name }}</div>
      </div>
      <div v-if="damageInfo.damage" class="mb-2">
        <strong>Damage:</strong>
        <div class="damage-info-value">{{ damageInfo.damage.name }}</div>
      </div>
      <div v-if="damageInfo.description" class="mb-2">
        <strong>Description:</strong>
        <div class="damage-info-value text-break">{{ damageInfo.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      damageImageModal: (state) =>
        state.vehicle.visualInspection.damageImageModal,
      damageInfo: (state) =>
        state.vehicle.visualInspection.damageInfo,
    })
  },
}
</script>

<style scoped>
.img-damage {
  max-height: 100%;
  width: auto;
  display: inline-block;
  float: none;
}
.damage-info-value {
  color: #1a3a6b;
}
</style>